export class NumberService {
  static isEven(num: number): boolean {
    return num % 2 === 0;
  }
}
